import { api } from '@/shared/api/httpClient'
import type { Connection, ConsentDecision, ConsentInfo, McpInfo } from '@/features/mcp/types'

export const mcpApi = {
  connections: () => api.get<Connection[]>('/mcp/connections/'),
  revoke: (id: number) => api.delete<void>(`/mcp/connections/${id}/`),
  info: () => api.get<McpInfo>('/mcp/info/'),

  consent: (req: string) => api.get<ConsentInfo>(`/oauth/consent/?req=${encodeURIComponent(req)}`),
  decide: (body: ConsentDecision) => api.post<{ redirect_to: string }>('/oauth/consent/', body),
}
